import { WorksSearchActionContext } from "@/context/WorksSearchProvider";
import { useContext } from "react";

export const useWorksSearchActions = () => {
  const context = useContext(WorksSearchActionContext);
  if (context === undefined) {
    throw new Error('useWorksSearchActions must be used within a WorksSearchProvider');
  }
  return context;
};